import { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { roleLinks } from "@/data/site";

export default function RoleMenu() {
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const rootRef = useRef<HTMLDivElement>(null);
  const btnRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e: MouseEvent) => {
      if (rootRef.current && !rootRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        setOpen(false);
        btnRef.current?.focus();
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const onButtonKeyDown = (e: React.KeyboardEvent<HTMLButtonElement>) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      setOpen(true);
      setActiveIndex((i) =>
        e.key === "ArrowDown"
          ? (i + 1) % roleLinks.length
          : i <= 0
            ? roleLinks.length - 1
            : i - 1
      );
    }
  };

  return (
    <div ref={rootRef} className="relative">
      <button
        ref={btnRef}
        type="button"
        onClick={() => setOpen((v) => !v)}
        onKeyDown={onButtonKeyDown}
        aria-label="Üye Girişi"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-controls="role-menu"
        className="inline-flex items-center justify-center gap-2 h-11 w-11 lg:w-auto lg:px-4 rounded-md border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors"
      >
        <i className="ri-user-3-line text-lg" aria-hidden="true"></i>
        <span className="hidden lg:inline text-sm font-semibold whitespace-nowrap">
          Üye Girişi
        </span>
        <i
          className={`hidden lg:inline ri-arrow-down-s-line text-base transition-transform ${
            open ? "rotate-180" : ""
          }`}
          aria-hidden="true"
        ></i>
      </button>

      {open && (
        <div className="absolute top-full right-0 mt-2 w-64 z-50">
          <div
            id="role-menu"
            role="menu"
            aria-label="Rol seçimi"
            className="rounded-lg border border-background-200 bg-background-50 p-1.5"
          >
            <p className="px-3 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wide text-foreground-400">
              Hesabına giriş yap
            </p>
            {roleLinks.map((r, i) => (
              <Link
                key={r.href}
                to={r.href}
                role="menuitem"
                onClick={() => setOpen(false)}
                onMouseEnter={() => setActiveIndex(i)}
                className={`flex items-center justify-between gap-3 rounded-md px-3 py-2.5 text-sm transition-colors ${
                  i === activeIndex
                    ? "bg-primary-50 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                <span className="whitespace-nowrap">{r.label}</span>
                <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true"></i>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}